import React, { FC } from "react";
import classNames from "classnames";
import { LinkButton } from "@app/components/common";
import { SwapSharp } from "@app/components/common/icons";
import { CURRENCY_TITLE, CURRENCY_ICON } from "@app/constants/currencies";
import { ILink } from "@app/models/storyblok/basic";
import { Currency } from "@app/types/currencies";

type Props = {
  from: Currency;
  to: Currency;
  link: ILink;
};

export const CurrencyCard: FC<Props> = ({ from, to, link }) => {
  const linkUrl = link.url.startsWith("/") ? link.url : `/${link.url}`;

  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-lg bg-blue-charcoal py-10",
        "lg:py-15",
        "xxl:rounded-3xl",
      )}
    >
      <div
        className={classNames(
          "flex flex-col items-center justify-center gap-y-8",
        )}
      >
        <div className={classNames("flex items-center gap-x-4.5")}>
          <div className="flex h-15 w-15 overflow-hidden rounded-full">
            {React.createElement(CURRENCY_ICON[from] ?? null)}
          </div>
          <SwapSharp className="h-7.5 w-7.5" />
          <div className="flex h-15 w-15 overflow-hidden rounded-full">
            {React.createElement(CURRENCY_ICON[to] ?? null)}
          </div>
        </div>
        <LinkButton
          to={linkUrl}
          label={`${CURRENCY_TITLE[from]} / ${CURRENCY_TITLE[to]}`}
        />
      </div>
    </div>
  );
};
